import { render, staticRenderFns } from "./CustomSidebar.vue?vue&type=template&id=c0c5ec74"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomSidebar.vue?vue&type=style&index=0&id=c0c5ec74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports